import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SessionExpiredPopup from './SessionExpiredPopup';
import {
    completeSessionExpiredLogout,
    subscribeToSessionExpiredPopup,
} from '../utils/sessionExpiredLogout';

export default function SessionExpiredPopupHost() {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const isLoginRoute = location.pathname.toLowerCase().includes('/login');

    useEffect(() => subscribeToSessionExpiredPopup(setOpen), []);

    return (
        <SessionExpiredPopup
            open={open && !isLoginRoute}
            handleClose={completeSessionExpiredLogout}
            errorCode={400}
            error="Session has expired. Logging out."
        />
    );
}
